import { render, staticRenderFns } from "./orderForSportMana.vue?vue&type=template&id=520f8b80"
import script from "./orderForSportMana.vue?vue&type=script&lang=js"
export * from "./orderForSportMana.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports